import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=c107a906&scoped=true&"
import script from "./FaqComponent.vue?vue&type=script&lang=js&"
export * from "./FaqComponent.vue?vue&type=script&lang=js&"
import style0 from "./FaqComponent.vue?vue&type=style&index=0&id=c107a906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c107a906",
  null
  
)

component.options.__file = "FaqComponent.vue"
export default component.exports